import URL from '@/http/vph/url'
import AjaxReq from '@/http/ajaxReq'

export default {
  /**
   * 热门搜索
   */
  hotSearch: async function() {
    let res = await AjaxReq({
      url: URL.HOT_SEARCH,
      method: 'get',
      data: {},
    })
    return res.data
  },
  /**
   * 搜索
   * @param {number} kw 关键字
   */
  search: async function(kw, pageNo) {
    let res = await AjaxReq({
      url: URL.SEARCH,
      method: 'get',
      data: {
        kw: kw,
        pageNo: pageNo,
      },
    })
    return res.data
  },
  /**
   * tab菜单
   * @param {number} kw 关键字
   */
  tabList: async function() {
    let res = await AjaxReq({
      url: URL.TAB_LIST,
      method: 'get',
      data: {},
    })
    return res.data
  },
  /**
   * tab菜单对应的商品列表
   * @param {number} tabId 菜单ID
   * @param {number} sort 1 销量正序  -1 销量倒叙  2 券后价正序  -2 券后价倒叙   空值 综合排序
   * @param {number} pageNo 页码
   * @param {number} pageSize 每页长度
   */
  tabGoodsList: async function(tabId, sort, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.TAB_GOODS_LIST,
      method: 'get',
      data: {
        tabId: tabId,
        sort: sort || '',
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * 商品详情
   * @param {number} goodsId 商品ID
   */
  goodsDetail: async function(goodsId) {
    let res = await AjaxReq({
      url: URL.GOODS_DETAIL,
      method: 'get',
      data: {
        goodsId: goodsId,
      },
    })
    return res.data
  },
  /**
   * 查询商品购买url 
   * @param {string} goodsId 商品ID
   * @param {string} type  share(分享链接)  buy(购买链接)
   */
  goodsDetailBuyUrl: async function(goodsId, type) {
    let res = await AjaxReq({
      url: URL.GOODS_DETAIL_BUY_URL,
      method: 'get',
      data: {
        goodsId: goodsId,
        type: type,
      },
    })
    return res.data
  },
  /**
   * 金豆合计
   */
  beanBalance: async function() {
    let res = await AjaxReq({
      url: URL.BEAN_BALANCE,
      method: 'get',
      data: {},
    })
    return res.data
  },
  /**
   * 金豆列表
   * @param {number} type  0:未结算  1:已结算
   */
  beanList: async function(type, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.BEAN_LIST,
      method: 'get',
      data: {
        type: type,
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * 已结算收益合计
   */
  settledProfitBalance: async function() {
    let res = await AjaxReq({
      url: URL.SETTLED_PROFIT_BALANCE,
      method: 'get',
      data: {},
    })
    return res.data
  },
  /**
   * 已结算收益列表
   * @param {number} type  0:全部  1:今日  2:本月  3:上月
   */
  settledProfitList: async function(type, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.SETTLED_PROFIT_LIST,
      method: 'get',
      data: {
        type: type,
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * 待结算收益合计
   */
  unsettledProfitBalance: async function() {
    let res = await AjaxReq({
      url: URL.UNSETTLED_PROFIT_BALANCE,
      method: 'get',
      data: {},
    })
    return res.data
  },
  /**
   * 待结算收益列表
   * @param {number} type  0:全部  1:今日  2:本月  3:上月
   */
  unsettledProfitList: async function(type, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.UNSETTLED_PROFIT_LIST,
      method: 'get',
      data: {
        type: type,
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * 我的订单
   * @param {number} state  0:全部 12:待结算 3:已结算 13:失效
   */
  orderList: async function(state, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.ORDER_LIST,
      method: 'get',
      data: {
        state: state,
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * 团队订单
   * @param {number} state  0:全部 12:待结算 3:已结算 13:失效
   */
  teamOrderList: async function(state, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.TEAM_ORDER_LIST,
      method: 'get',
      data: {
        state: state,
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
}
